import React from 'react'
import PropTypes from "prop-types"
import {FormatUtcDateAsLocal} from '../../../../../../helpers/datetime'
import * as Badges from '../../../../../../components/badges'
import moment from '../../../../../../helpers/moment'

const PoolAvailabilityOverrideChanged = (props) => {
  let data
  let payload = JSON.parse(props.item.payload)
  let formattedDuration = moment.duration(payload.To).format("mm [minutes] s [seconds]")
  data = `Availability set to ${formattedDuration}`

  return <tr>
    <td><Badges.PoolAvailabilityOverrideChanged/></td>
    <td>{data}</td>
    <td>{FormatUtcDateAsLocal(props.item.createdUtc)}</td>
    <td>{props.item.createdBy}</td>
  </tr>
}

PoolAvailabilityOverrideChanged.propTypes = {
  item: PropTypes.object
}

export default PoolAvailabilityOverrideChanged



// WEBPACK FOOTER //
// ./src/containers/pools/details/logs/components/poolAvailabilityOverrideChanged/index.js